import { Component, Inject, OnInit, Self } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Utils } from '../../../../utils/utils';
import { DestroyService } from '../../../../services/destroyservice';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'jcobrule-modal.component',
    templateUrl: './jcobrule-modal.component.html',
    styleUrls: ['./jcobrule-modal.component.less'],
    providers: [DestroyService],
    standalone: false
})
export class JCobRuleModalComponent implements OnInit {
    fileContent: string | null = null;
    fileContentXML: SafeHtml | null = null;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder
        , private dialogRef: MatDialogRef<JCobRuleModalComponent>
        , private http: HttpClient
        , @Inject('BASE_URL') private baseUrl: string
        , private dialogForm: MatDialog
        , private _formBuilder: FormBuilder
        , private toastrService: ToastrService
        , @Self() private readonly destroy$: DestroyService
        , private sanitizer: DomSanitizer) { }

    ngOnInit(): void {
        Utils.httpGetJCOBReleaseFileContent(
            this.http,
            this.baseUrl,
            this.data.ruleFileId,
            this,
            (tthis: JCobRuleModalComponent, result: any) => {
                tthis.fileContent = result;
                tthis.fileContentXML = tthis.sanitizer.bypassSecurityTrustHtml(
                    tthis.escapeXml(result)
                );
            }
        );
    }

    onCancel(): void { }

    escapeXml(xml: string): string {
        if (!xml) return '';
        return xml
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }

    downloadContent(): void {
        if (!this.fileContent) return;
        const blob = new Blob([this.fileContent], { type: 'text/plain' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `jcob_rule_${this.data.ruleFileId}.txt`;
        a.click();
        window.URL.revokeObjectURL(url);
    }
}